/* eslint-disable no-case-declarations */
import { ANIMATION_STYLE_LIST, GIF_RESOLUTION, VIDEO_RESOLUTION } from '../../config/dataConfig/FJFake3dData';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData';
import FJConfig from '../../config/FJConfig';
import FJS3Config from '../../config/FJS3Config';
import FJConstant from '../../constants/FJConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJFake3dExportStore from '../../store/FJFake3dExportStore';
import {
    // renderCanvas,
    setImages,
    triggerAnimationRender,
    updateAnimationDuration,
    updateIntensity,
    updateIsReverse,
    updateLoop,
} from '../../store/FJFake3dStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import {
    setDeepMapImage,
    setExportProgress,
    setSettingStep,
    setOriginImage,
    setUploadStatus,
    setPreviewImage,
    setAnimationStyle,
    setDirection,
    setIntensity,
    setDuration,
    setReturnAnimation,
    setReverse,
} from '../slices/FJSliceFake3d';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import { setSliceUploadImageInfoAction } from '../slices/FJSliceImageToImage.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';
let f_currentTaskId = '';
let f_eventId = '';
let f_preUploadStatus = '';
const _checkIsCurrentTask = id => {
    return id === f_currentTaskId;
};
const FJActionFake3d = {
    resetAction: function () {
        return dispatch => {
            dispatch(setPreviewImage({}));
            dispatch(setOriginImage({}));
            dispatch(setDeepMapImage({}));
            dispatch(setUploadStatus(FJConstant.DEFAULT));
            dispatch(setSettingStep(FJConstant.DEFAULT));
            // dispatch(setAnimationStyle(ANIMATION_STYLE_LIST[0].type));
            // dispatch(setDirection(ANIMATION_STYLE_LIST[0].directions[0].type));
            // dispatch(setIntensity(50));
            // dispatch(setDuration(4));
            // dispatch(setReverse(true));
        };
    },
    uploadImageAction: function (file) {
        return async dispatch => {
            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            };
            const isImage = FJUtil.isImage(file);

            if (isImage) {
                const data = await FJCompressedImageStore.compressImageByFile(file, { maxPixel: 1000 });

                if (data) {
                    dispatch(setPreviewImage(data));
                    dispatch(FJActionFake3d.generateDepthMapAction(data.src));
                } else {
                    __fileError();
                }
            } else {
                __fileError();
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async dispatch => {
            const { size, name, id } = options;
            let data;
            if (size.width > 1000 || size.height > 1000) {
                data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            if (data) {
                dispatch(setPreviewImage(data));
                dispatch(FJActionFake3d.generateDepthMapAction(data.src));
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },
    updateIntensityAction: function () {
        return (dispatch, getState) => {
            const { animationStyle, direction, intensity } = getState().fake3d;
            updateIntensity(intensity, animationStyle, direction);
            triggerAnimationRender();
        };
    },
    setAnimationStyleAction: function (value) {
        return dispatch => {
            const directionType = ANIMATION_STYLE_LIST.find(item => item.type === value).directions[0].type;
            const intensity = 50;
            dispatch(setAnimationStyle(value));
            dispatch(setDirection(directionType));
            dispatch(setIntensity(intensity));
            dispatch(FJActionFake3d.updateIntensityAction());
        };
    },
    setDirectionAction: function (value) {
        return dispatch => {
            dispatch(setDirection(value));
            dispatch(FJActionFake3d.updateIntensityAction());
        };
    },
    setIntensityAction: function (value, isUpdateRender) {
        return dispatch => {
            dispatch(setIntensity(value));
            isUpdateRender && dispatch(FJActionFake3d.updateIntensityAction());
        };
    },
    setDurationAction: function (value, isUpdateRender) {
        return dispatch => {
            dispatch(setDuration(value));
            updateAnimationDuration(value);
            isUpdateRender && triggerAnimationRender();
        };
    },
    setReturnAnimationAction: function (value) {
        return dispatch => {
            dispatch(setReturnAnimation(value));
            updateLoop(value);
            triggerAnimationRender();
        };
    },
    setReverseAction: function (value) {
        return dispatch => {
            dispatch(setReverse(value));
            updateIsReverse(value);
            triggerAnimationRender();
        };
    },
    generateDepthMapAction: function (fileUrl) {
        return async (dispatch, getState) => {
            f_preUploadStatus = getState().fake3d.uploadStatus;
            dispatch(setUploadStatus(FJConstant.UPLOADING));
            const currentTaskId = new Date().getTime();
            f_currentTaskId = currentTaskId;
            const _error = () => {
                dispatch(FJActionFake3d.generateErrorAction());
            };
            try {
                // 2.上传
                const blob = await FJUtil.getBlobByUrl(fileUrl);
                const id = await FJUtil.hashEncode(blob);
                const key = FJConfig.originalImageKey + `${id}.png`;
                const result = await FJImageStore.upLoadFileToS3Async(blob, key);
                if (!result) {
                    _error();
                    return;
                }
                if (!_checkIsCurrentTask(currentTaskId)) return;
                const imageUrl = FJS3Config.S3_SERVER_HOST + key;
                // 3.创建任务
                const request = async () => {
                    return await FJNetworkStore.generateDepthMap(imageUrl);
                };
                f_eventId = await FJActionCommon.createRequestTask(request, dispatch);

                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!f_eventId) {
                    _error();
                    return;
                }
                dispatch(FJActionFake3d.pollingDepthMapTaskAction(currentTaskId));
            } catch (error) {
                _error();
            }
        };
    },
    pollingDepthMapTaskAction: function (currentTaskId) {
        let timer = null;
        let errorTime = 0;
        return (dispatch, getState) => {
            const { previewImage } = getState().fake3d;
            const _error = () => {
                dispatch(FJActionFake3d.generateErrorAction());
                clearTimeout(timer);
                timer = null;
            };
            const _clear = () => {
                clearTimeout(timer);
                timer = null;
            };
            let isStopPolling = false;

            const _request = async () => {
                try {
                    const result = await FJNetworkStore.getTaskState(f_eventId);
                    if (!result) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            _error();
                            return;
                        } else {
                            timer = setTimeout(_request, 1000);
                        }
                        return;
                    }
                    const jobState = result.job_state;
                    switch (jobState) {
                        case 'succeeded':
                            if (result?.out_put[0]) {
                                const outPutData = result?.out_put[0];
                                const depthMapSrc =
                                    FJS3Config.S3_SERVER_HOST + FJConfig.resultImageKey + outPutData.result;
                                const depthMapLocalSrc = URL.createObjectURL(await FJUtil.getBlobByUrl(depthMapSrc));
                                const depthMapInfo = {
                                    src: depthMapLocalSrc,
                                    ...JSON.parse(outPutData.info),
                                };
                                dispatch(setOriginImage(previewImage));
                                dispatch(setDeepMapImage(depthMapInfo));
                                setImages(previewImage.src, depthMapInfo.src);
                                dispatch(setUploadStatus(FJConstant.SUCCESS));
                                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                                FJUtil.eaLog('3d image upload', { 'upload source': 'user' });
                            } else {
                                _error();
                            }
                            isStopPolling = true;
                            break;
                        case 'waiting':
                            dispatch(setUploadStatus(FJConstant.WAITING));
                            break;
                        case 'processing':
                            dispatch(setUploadStatus(FJConstant.GENERATING));
                            break;
                        case 'canceled':
                            isStopPolling = true;
                            break;
                        case 'failed':
                            _error();
                            isStopPolling = true;
                            break;
                        default:
                            break;
                    }
                    if (isStopPolling || !_checkIsCurrentTask(currentTaskId)) {
                        _clear();
                    } else timer = setTimeout(_request, TASK_POLLING_INTERVAL);
                } catch (error) {
                    _error();
                }
            };
            timer = setTimeout(_request, TASK_POLLING_INTERVAL);
        };
    },
    generateErrorAction: function () {
        return async dispatch => {
            dispatch(setUploadStatus(f_preUploadStatus));
            FJMessageStore.addMessage(FJLocalStore._('failed-to-process-this-image-please-try-again'), 'error');
        };
    },
    cancelDepthMapTaskAction: function (cancelTask = true) {
        return async dispatch => {
            try {
                f_currentTaskId = null;
                cancelTask && f_eventId && (await FJNetworkStore.cancelTask(f_eventId));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                f_preUploadStatus && dispatch(setUploadStatus(f_preUploadStatus));
            }
        };
    },
    exportAction: function () {
        return async (dispatch, getState) => {
            const {
                settingStep,
                exportFormate: formate,
                exportResolution: resolution,
                animationStyle,
                direction,
                intensity,
                duration,
                returnAnimation,
                reverse,
                originImage,
            } = getState().fake3d;

            let { creditNumber } = getState().common;

            if (settingStep === FJConstant.DEFAULT) {
                dispatch(setSettingStep(FJConstant.SETTING));
                FJUtil.eaLog('3d image export click', { style: animationStyle, return: returnAnimation, reverse });
            } else if (settingStep === FJConstant.SETTING) {
                FJUtil.eaLog('3d image download click', {
                    style: animationStyle,
                    return: returnAnimation,
                    reverse,
                    resolution: formate + ' ' + resolution + 'P',
                });
                const resolutions = formate === 'video' ? VIDEO_RESOLUTION : GIF_RESOLUTION;
                const useCredits = resolutions.find(item => item.type === resolution)?.price;

                const userSpaceType = await FJUtil.checkUserSpace();
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return;
                }

                if (useCredits > creditNumber && !FJUtil.isLocalhost()) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
                dispatch(setExportProgress(0));

                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': 'credit', tool });

                const __exportError = () => {
                    dispatch(setSettingStep(FJConstant.SETTING));
                    FJMessageStore.addMessage(
                        FJLocalStore._('sorry-there-was-an-error-when-exporting-your-video-please-try-again'),
                        'error',
                    );
                };

                FJFake3dExportStore.exportVideo({
                    formate,
                    resolution,
                    callback: async result => {
                        const { data = {}, type } = result;
                        switch (type) {
                            case FJConstant.PROGRESS:
                                dispatch(setExportProgress(Math.min(0.99, data)));
                                break;
                            case FJConstant.SUCCESS:
                                try {
                                    const isAddUse = await FJNetworkStore.addUseValue(8, useCredits);
                                    const depthMapData = JSON.stringify({
                                        animationStyle,
                                        direction,
                                        intensity,
                                        duration,
                                        returnAnimation,
                                        reverse,
                                        originWidth: originImage.width,
                                        originHeight: originImage.height,
                                    });

                                    const isUpdateDeepMap = f_eventId
                                        ? await FJNetworkStore.updateDepthMapInfo(f_eventId, depthMapData)
                                        : true;

                                    if ((isAddUse && isUpdateDeepMap) || FJUtil.isLocalhost()) {
                                        dispatch(setExportProgress(1));
                                        FJFake3dExportStore.download();
                                        dispatch(setSettingStep(FJConstant.SUCCESS));
                                        dispatch(setExportProgress(data));
                                        dispatch(FJActionCommon.updateHistoryListAction());
                                        FJUtil.updateAllCreditInfo();
                                    } else {
                                        dispatch(setSettingStep(FJConstant.SETTING));
                                        FJMessageStore.addMessage(
                                            FJLocalStore._(
                                                'sorry-there-was-an-error-when-exporting-your-video-please-try-again',
                                            ),
                                            'error',
                                        );
                                    }
                                    FJUtil.eaLog('ai tool generate success', {
                                        tool: FJUtil.getToolName(),
                                        'credit&free': 'credit',
                                    });
                                } catch (error) {
                                    __exportError();
                                }
                                break;
                            case FJConstant.ERROR:
                                __exportError();
                                break;
                            default:
                                break;
                        }
                    },
                });
                dispatch(setSettingStep(FJConstant.GENERATING));
            }
        };
    },

    backExportAction: function () {
        return async (dispatch, getState) => {
            const { settingStep } = getState().fake3d;
            switch (settingStep) {
                case FJConstant.SETTING:
                    dispatch(setSettingStep(FJConstant.DEFAULT));
                    break;
                case FJConstant.GENERATING:
                    FJFake3dExportStore.cancelExport();
                    dispatch(setSettingStep(FJConstant.SETTING));
                    break;
                case FJConstant.SUCCESS:
                    dispatch(setSettingStep(FJConstant.SETTING));
                    break;
                default:
                    break;
            }
        };
    },
    editFake3dHistoryAction: function (data, cancelCallback) {
        return async dispatch => {
            const _apply = async () => {
                try {
                    const { imgUrl: originImageUrl, depthMapUrl, depthMapInfo, eventId } = data;
                    const originImageBlob = await FJUtil.getBlobByUrl(originImageUrl + '?v=' + Date.now());
                    const originImageInfo = await FJCompressedImageStore.compressImageByFile(originImageBlob);
                    const depthMapImageBlob = await FJUtil.getBlobByUrl(depthMapUrl + '?v=' + Date.now());
                    const depthMapImageInfo = await FJCompressedImageStore.compressImageByFile(depthMapImageBlob);
                    dispatch(setOriginImage(originImageInfo));
                    dispatch(setDeepMapImage(depthMapImageInfo));
                    FJUtil.eaLog('3d image upload', { 'upload source': 'history' });

                    dispatch(setUploadStatus(FJConstant.SUCCESS));
                    await setImages(originImageInfo.src, depthMapImageInfo.src);
                    f_eventId = eventId;
                    if (depthMapInfo) {
                        const { animationStyle, direction, intensity, duration, returnAnimation, reverse } =
                            depthMapInfo;
                        dispatch(setAnimationStyle(animationStyle));
                        dispatch(setDirection(direction));
                        dispatch(setIntensity(intensity));
                        dispatch(setDuration(duration));
                        dispatch(setReturnAnimation(returnAnimation));
                        dispatch(setReverse(reverse));
                    }
                    triggerAnimationRender();
                    cancelCallback && cancelCallback();
                    dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                } catch (error) {
                    cancelCallback && cancelCallback();
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                }
            };
            dispatch(FJActionFake3d.replaceImageConfirmAction(_apply, cancelCallback));
        };
    },

    editPresetAction: function (data, cancelCallback) {
        return dispatch => {
            const _apply = async () => {
                const { originImage, deepMapImage, animationStyle, directionType, intensity } = data;
                try {
                    // await renderCanvas(originImage.src);
                    //检测网络问题
                    const originalImage = await FJUtil.loadImageAsync(originImage.src);
                    const depthMapImage = await FJUtil.loadImageAsync(deepMapImage.src);
                    if (!originalImage || !depthMapImage) {
                        throw new Error('network error');
                    }
                    dispatch(setUploadStatus(FJConstant.SUCCESS));
                    dispatch(setAnimationStyle(animationStyle));
                    dispatch(setDirection(directionType));
                    dispatch(setIntensity(intensity));
                    dispatch(setOriginImage(originImage));
                    dispatch(setDeepMapImage(deepMapImage));
                    FJUtil.eaLog('3d image upload', { 'upload source': 'presets' });

                    await setImages(originImage.src, deepMapImage.src);
                    triggerAnimationRender();
                    cancelCallback && cancelCallback();
                } catch (e) {
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    cancelCallback && cancelCallback();
                }
            };
            dispatch(FJActionFake3d.replaceImageConfirmAction(_apply, cancelCallback));
        };
    },
    replaceImageConfirmAction: function (apply, cancelCallback) {
        return (dispatch, getState) => {
            const { originImage, deepMapImage, settingStep, uploadStatus } = getState().fake3d;
            const isNeedConfirm =
                originImage?.src ||
                deepMapImage.src ||
                settingStep !== FJConstant.DEFAULT ||
                uploadStatus !== FJConstant.DEFAULT;

            if (isNeedConfirm) {
                dispatch(
                    FJActionModal.showWarningModalAction({
                        title: FJLocalStore._('replace-image'),
                        content: FJLocalStore._('are-you-sure-to-replace-the-current-image'),
                        footerDates: [
                            {
                                btnType: FJConstant.SUBMIT,
                                btnText: FJLocalStore._('replace'),
                                btnCallback: async () => {
                                    if (settingStep === FJConstant.GENERATING) {
                                        FJFake3dExportStore.cancelExport();
                                        dispatch(setSettingStep(FJConstant.DEFAULT));
                                    }
                                    if (uploadStatus) {
                                        dispatch(FJActionFake3d.cancelDepthMapTaskAction(false));
                                    }
                                    apply();
                                },
                            },
                            {
                                btnType: FJConstant.CANCEL,
                                btnText: FJLocalStore._('cancel'),
                                btnCallback: () => {
                                    cancelCallback && cancelCallback();
                                },
                            },
                        ],
                        closeCallback: cancelCallback,
                    }),
                );
            } else apply();
        };
    },
    initFake3dProjectActon: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(FJActionFake3d.uploadImageAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(FJActionFake3d.uploadImageAction(blob));
                }
            }
        };
    },
};
export default FJActionFake3d;
